// extracted by mini-css-extract-plugin
var _1 = "Tk44_";
var _2 = "kxT5Y";
export { _1 as "overlapBorder", _2 as "segButton" }
